<template>
<div class="spring-rules">
    <div class="box">
        <div class="title">活动主题</div>
        <div class="infos">
           
            带话题 <span>#记录春天随手拍#</span> ，发布图文/视频帖子，即成功参与活动。    
        </div>
        <div class="title">参与方式</div>
        <div class="infos">
            发帖可以参考以下两个方向：   
        </div>
        <div class="infos">
            <strong>01</strong>
            <span>晒春天随拍： </span>
            晒樱花，晒春游，晒美食，晒心情，晒着晒那的……春天，果然很美
        </div>
        <div class="infos">
            <strong>02</strong>
            <span>拍拍我家小院：</span>
            春天到了，小院绿油油活力满满的，花儿也都开了 ​，随手拍一拍吧
        </div>
        <div class="title">活动奖励/评选方式</div>
        <div class="infos only-pc">优质奖，20名，每人奖励10加币礼品卡（或等值微信红包） </div>
        <div class="infos only-pc">
            结合帖子内容的文字图片或视频质量，以及帖子的浏览量、回复量、点赞量，在精选作品中选择20名获奖者。每日精选参与奖，不限量；被设置为精华帖，有机会获得每日精选参与奖，可获得5-10元不等微信红包。
        </div>
        <div class="infos only-mobile">优质奖，每人奖励10加币礼品卡（或等值微信红包）</div>
        <div class="infos only-mobile">每日精选参与奖，每人获得5-10元不等微信红包</div>
    </div>
    <a href="https://forum.yorkbbs.ca/detail/2e5b17d3-fab6-4cff-b065-669418f28b77?topic=chat" target="_blank" class="detail-enter">活动详情 &gt;</a>
</div>
</template>
<script>
export default {
    name:'SpringRules2023',
    data(){
        return {

        }
    }
}
</script>
<style lang="less" scoped>

.spring-rules{
    background: url(https://media5.imgyb.xyz/media/v1/image/6c7055e40042c1c061f86ecd38c96d9b.png) no-repeat; background-size: 100% 100%;
    padding: 40px 110px 50px 60px; position: relative; margin-top: 45px; margin-bottom: 35px;
    .title{
        font-size: 16px; line-height: 24px; color: #F25029; font-weight: bold; margin-bottom: 5px; margin-top: 15px;
    }
    .infos{
        font-size: 16px; line-height: 26px; margin-bottom: 5px;
        strong{margin-right: 3px;}
        span{
            font-size: 16px; line-height: 26px; font-weight: bold; background:linear-gradient(rgba(255,255,255,0) 0%,rgba(255,255,255,1) 50%,rgba(255,255,255,1) 100% );
        }
    }

    &:before{
        content:''; display: block; position: absolute; left: 50%; bottom: -17px; 
        width: 60px; height: 58px; background: url(./assets/flower2.png) no-repeat; background-size: 100% 100%;
    }
    &:after{
        content:''; display: block; position: absolute; right: -65px; top: -33px;
        width: 149px; height: 134px; background: url(./assets/flower1.png) no-repeat; background-size: 100% 100%;
    }
    .detail-enter{
        position: absolute; right: 110px; bottom: 45px; color: #F25029; font-size: 16px; line-height: 24px;
        text-decoration: underline;
    }
}

@media screen and (max-width:768px){
    .spring-rules{
        padding: 15px 20px 65px;  margin-top: 20px;
        .detail-enter{right: 30px;}
        &:after{display: none;}
        .infos{ line-height: 24px;}
    }
}
</style>